import React from 'react';
import Highlighter from './Highlighter';
import TabularDataLink from './TabularDataLink';
import { Xrefs } from './Xref';

interface Subterm {
    term: string;
    breadcrumbs: string;
    xrefs: Array<string>;

}

interface Term {
    term: string;
    xrefs: Array<string>;
    subterms: Array<Subterm>;
}

const IndexTermList = (props: { terms: Array<Term>, searchTerm: string }) => {
    const termList = props.terms.map((term: Term) => {
        const subtermsList = term.subterms.map((subterm: Subterm) => {
            const fixedSubterm = fixSubterms(subterm.term);
            const splitsubterm = fixedSubterm.split('|').map((t: string, index: number) => {
                if (isTabularLink(t)) {
                    return (
                        <span key={index + t}>
                            <TabularDataLink linkTo={t} tabDataClass={`${index+ + 1 >= fixedSubterm.split('|').length ? 'strong' : ''}`} />
                        </span>
                    )
                } else if (index === fixedSubterm.split('|').length - 2) {
                    return (
                        <span key={index + t}>
                            <Highlighter value={t} searchTerm={props.searchTerm} />
                        </span>
                    )
                } else {
                    return (
                        <span key={index + t} className="text-muted font-weight-normal">
                            <Highlighter value={t} searchTerm={props.searchTerm} />
                        </span>)
                }
            })

            return (
                <li key={subterm.term} className="result-success strong">
                    { splitsubterm }
                    { subterm.xrefs[0] ? <Xrefs starter={subterm.xrefs[0][0]} linkTo={subterm.xrefs[0][1]} /> : '' }
                </li>
            )
        })

        const splitterm = term.term.split('|').map((t: string, index: number) => {
            if (index % 2 === 0) {
                return (
                    <span key={index + t}>
                        <Highlighter value={t} searchTerm={props.searchTerm} />
                    </span>
                )
            } else {
                return (
                    <span key={index + t}>
                        <TabularDataLink linkTo={t} />
                    </span>
                )
            }
        })
        return (
            <li key={term.term}>
                {/* <!-- display mainterm and it's xrefs --> */}
                <span className="main-term">
                    {splitterm}
                </span>
                { term.xrefs[0] ? <Xrefs starter={term.xrefs[0]} linkTo={term.xrefs[1]} /> : '' }
                <ul className="subTerms">
                    {subtermsList}
                </ul>
            </li>
        )
    })

    return (
        <ul className="root list-unstyled" ng-if="hasResults()">
            <li>
                <ul className="main-term-list">
                    {termList}
                </ul>
            </li>
        </ul>
    );
}

const fixSubterms = function (term: string) {
    const s1 = term.split("|");
    const s2 = s1.map((t, index) => {
        const isLink = isTabularLink(t);
        if (isLink && s1.length !== index + 1) {
            return `|${t}|`
        } else if (isLink) {
            return `|${t}`
        }
        return ` ${t}`;
    })
    return s2.join("")
}

const isTabularLink = (term: string) => {
    var majorCode = '([A-Za-z]\\d[A-Za-z\\d])';
    var minorCode = '((?:[\\dA-Za-z]{1,2}\\d?)?)';
    var hasMajorCode = new RegExp('^' + majorCode);
    var hasFullCode = new RegExp('^\\[*' + majorCode + '(\\.)' + minorCode + '\\]*');

    return hasFullCode.test(term) || (hasMajorCode.test(term) && !containsFalseCode(term));
}

const containsFalseCode = function (text: string) {
    var falseCodes = [
        'B12',
        'G6PD',
        'H1N1',
        'H5N1',
        'M5A',
        'M5B',
        'C99M',
        'L98AU',
        'O157',
        'C677',
    ];
    for (var i = 0; i < falseCodes.length; i++) {
        if (text.indexOf(falseCodes[i]) !== -1) {
            return true;
        }
    }
    return false;
};

export default IndexTermList;


